var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-slide d-flex flex-row justify-space-around",style:({
    width: typeof _vm.width === 'string' && _vm.width.indexOf('%') !== -1
      ? _vm.width
      : _vm.width + 'px',
    height: typeof _vm.height === 'string' && _vm.height.indexOf('%') !== -1
      ? _vm.height
      : _vm.height + 'px',
    background: _vm.background || 'transparent'
  })},[_c('v-btn',{staticClass:"c-slide__left",attrs:{"icon":"","disabled":_vm.disableLeft},on:{"click":_vm.toLeftHandler}},[_c('v-img',{attrs:{"src":("" + (require('@/assets/icon_slide_left.png'))),"max-width":"22","max-height":"22"}})],1),_c('v-btn',{staticClass:"c-slide__right",attrs:{"icon":"","disabled":_vm.disableRight},on:{"click":_vm.toRightHandler}},[_c('v-img',{attrs:{"src":("" + (require('@/assets/icon_slide_right.png'))),"max-width":"22","max-height":"22"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }